import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, timeout: 30000 });

export const getStatus = () => http.get("/status").then((r) => r.data);
export const getMarkets = () => http.get("/markets").then((r) => r.data);
export const getAnalyses = (params) => http.get("/analyses", { params }).then((r) => r.data);
export const getCandidates = () => http.get("/candidates").then((r) => r.data);
export const getDetail = (ticker) => http.get(`/analyses/${ticker}`).then((r) => r.data);
export const runScan = (scope) => http.post("/scan/run", { scope }).then((r) => r.data);
export const getScans = () => http.get("/scans").then((r) => r.data);
export const getAlertHistory = () => http.get("/push/history").then((r) => r.data);

export default http;
